import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAnalyticsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'customer-service-helpcenter-analytics',
	path: '/jira/helpcenter/analytics',
};
